import { useState } from 'react';
import { useAccount, useMsal } from '@azure/msal-react';
import { getAuthenticatedClient } from '../Utils/tokenHelper';
import { enableFrontdoor } from '../Utils/features';

const BASE_URL = enableFrontdoor ? process.env.REACT_APP_PRICER_API_V3_BASE_URL_FRONTDOOR : process.env.REACT_APP_PRICER_API_V3_BASE_URL;

export default function usePricerTypeLookupApi() {
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [result, setResult] = useState(null);
    const { accounts, instance } = useMsal();
    const account = useAccount(accounts[0]);

    const executePricerTypeSelectionRequest = async (request) => {
        setLoading(true);
        setSuccess(false);
        setError(null);
        setResult(null);

        try {
            const { data } = await (await getAuthenticatedClient({
                url: `${BASE_URL}/claims/pricer-type/lookup`,
                method: 'POST',
                account,
                msalInstance: instance,
                body: {
                    ...request
                }
            }));
            
            setResult(data);
            setSuccess(true);
        } catch (e) {
            setError(e);
        } finally {
            setLoading(false);
        }
    };

    const executeReset = () => {
        setLoading(false);
        setSuccess(false);
        setError(null);
        setResult(null);
    }

    return {
        loading,
        success,
        error,
        result,
        execute: executePricerTypeSelectionRequest,
        reset: executeReset
    };
}